import React, { useEffect, useState, memo } from "react";
import ReactDOM from "react-dom";
import PersonalModal from "./PersonalModal";
import ContactModal from "./ContactModal";
import SocialModal from "./SocialModal";
import HakkimdaModal from "./HakkimdaModal";
import SkillsModal from "./SkillsModal";
import LanguageModal from "./LanguageModal";
import EducationModal from "./EducationModal";
import PositionModal from "../projeler/PositionModal";
import PositionCard from "../projeler/PositionCard";
import { useDispatch, useSelector } from "react-redux";
import { updateUserProfile } from "../../redux/actions/userActions";
import { toast } from "react-toastify";

const ModalComponent = ({
  type,
  onClose,
  options: propOptions,
  onPositionAdd,
}) => {
  const dispatch = useDispatch();

  const { loading, error, user } = useSelector((state) => state.user);
  const [skills, setSkills] = useState(
    user?.data?.skills?.map((s) => s.name) || []
  );
  const [languageLevels, setLanguageLevels] = useState(
    user?.data?.languages || [{ language: "", level: "" }]
  );
  const [options, setOptions] = useState(propOptions || []);
  const [education, setEducation] = useState(user?.data?.edu_cert || []);
  const [birthDate, setBirthDate] = useState(null);

  const [positionFormData, setPositionFormData] = useState({
    positionName: "",
    expectations: [],
  });

  useEffect(() => {
    setOptions(propOptions || []);
  }, [propOptions]);

  const modalRefs = {
    "Kişisel Bilgiler": "personalData",
    "İletişim Bilgileri": "contactData",
    "Sosyal Medya Hesapları": "social_medias",
    Hakkımda: "about",
    Beceriler: "skills",
    Dilbilgisi: "languages",
    "Eğitim ve Sertifikalar": "edu_cert",
    "Yeni Pozisyon Ekle": "positionData",
  };

  useEffect(() => {
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "auto";
      window.scrollTo(0, scrollY);
    };
  }, []);

  const handlePositionChange = (data) => {
    setPositionFormData(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (type === "Yeni Pozisyon Ekle") {
      if (onPositionAdd && positionFormData.positionName) {
        onPositionAdd(positionFormData);
        onClose();
      }
      return;
    }

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    const section = modalRefs[type];

    if (section) {
      let payload;
      if (section === "social_medias") {
        payload = {
          social_medias: Object.entries(data)
            .filter(([key, value]) => value)
            .map(([key, value]) => `${key}:${value}`),
        };
      } else if (section === "personalData") {
        payload = {
          name: data.name || "",
          gender: data.gender || "",
          birthDate: birthDate ? birthDate.toISOString() : "",
          address:
            data.country && data.city
              ? `${data.country} - ${data.city}`
              : user?.address || "",
          position: data.position || "",
        };
        delete payload.country;
        delete payload.city;
      } else if (section === "contactData") {
        payload = {
          email: data.email || "",
          telephone: data.telephone || "",
          isEmailVerified:
            data.email === user?.email ? user?.isEmailVerified : false,
        };
      } else if (section === "skills") {
        payload = {
          skills: skills.length > 0 ? skills : [],
        };
      } else if (section === "about") {
        payload = {
          about: data.about || "",
        };
      } else if (section === "languages") {
        payload = {
          languages: languageLevels.filter(
            (lang) => lang.language && lang.level
          ),
        };
      } else if (section === "edu_cert") {
        payload = {
          edu_cert: education.length > 0 ? education : [],
        };
      } else {
        payload = { [section]: data[section] || "" };
      }

      dispatch(updateUserProfile({ section, data: payload }))
        .unwrap()
        .then(() => {
          onClose();
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status) {
              console.error("Backend Hatası - Status:", error.response.status);
            }
            if (error.response.data) {
              console.error("Backend Hatası - Data:", error.response.data);
            }
          }
        });
    }
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-whiteBg/80">
      <div
        className={`bg-whiteBg w-[627px] h-auto relative flex flex-col p-4 shadow-cardShadow hover:shadow-hoverShadow rounded-2xl divide-y-[1px] divide-lineGray border-[1px] m-4 overflow-y-auto max-h-[80vh] ${
          type === "Kişisel Bilgiler" ? "mt-24" : ""
        }`}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl text-dark font-medium">{type}</h2>
          <button className="text-grayy" onClick={onClose}>
            ✖
          </button>
        </div>
        <form onSubmit={handleSubmit} className="py-4">
          {type === "Kişisel Bilgiler" && (
            <PersonalModal onDateChange={setBirthDate} />
          )}
          {type === "İletişim Bilgileri" && <ContactModal />}
          {type === "Sosyal Medya Hesapları" && <SocialModal />}
          {type === "Hakkımda" && <HakkimdaModal />}
          {type === "Beceriler" && (
            <SkillsModal
              initialSkills={user?.data?.skills?.map((s) => s.name) || []}
              options={options}
              onSkillsUpdate={(updatedSkills) => setSkills(updatedSkills || [])}
            />
          )}
          {type === "Dilbilgisi" && (
            <LanguageModal
              initialLanguages={
                user?.data?.languages || [{ language: "", level: "" }]
              }
              onLanguagesUpdate={(updatedLanguages) =>
                setLanguageLevels(
                  updatedLanguages || [{ language: "", level: "" }]
                )
              }
            />
          )}
          {type === "Eğitim ve Sertifikalar" && (
            <EducationModal
              initialEducation={user?.data?.edu_cert || []}
              onEducationUpdate={(updatedEducation) =>
                setEducation(updatedEducation || [])
              }
            />
          )}
          {type === "Yeni Pozisyon Ekle" && (
            <PositionModal onChange={handlePositionChange} />
          )}
          {error && (
            <p className="text-red-500 text-sm bg-red-50 p-3 rounded-lg mt-4 mb-2">
              {error}
            </p>
          )}
          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="btn-white text-dark"
            >
              İptal
            </button>
            <button type="submit" className="btn-green text-dark">
              Kaydet
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export const Modal = memo(ModalComponent);

// Also keep the default export for backward compatibility
export default Modal;
